import React, { useContext } from 'react';
import { Modal, Button, Row, Col, Typography, Divider, Select } from 'antd';
import { Formik, Field, Form } from 'formik';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import moment from 'moment';
import safeRead from 'safely-read';
import { Item, ItemContainer } from './style';
import formatPrice from '~/services/utils/formatPrice';
import AutoCompleteSelect from '~/components/DataEntry/AutoCompleteSelect';
import InputCurrency from '~/components/DataEntry/InputCurrency/';
import Input from '~/components/DataEntry/Input';
import { useSearchTeams, PostPayableRequest } from './index';
import { CollapsePanelContext } from '../../CollapseList';

export default function PackageSolicitationModal({
  packageSolicitationModalVisible,
  setPackageSolicitationModalVisible,
}) {
  const {
    user,
    key,
    month,
    year,
    fetchTableData,
    setTableData,
    setLoadingTableData,
    fetchCompensatoryTime,
    setCompensatoryTime,
    setConsolidatedProduction,
    fetchConsolidatedProduction,
  } = useContext(CollapsePanelContext);

  const { teamsResponse, setSearch, loading } = useSearchTeams();

  const { Text, Title } = Typography;
  return (
    <Modal
      visible={packageSolicitationModalVisible}
      onCancel={() => setPackageSolicitationModalVisible(false)}
      footer={null}
      closable
      destroyOnClose
      width={415}
      title={<Title level={4}>Solicitação de Pacote </Title>}
    >
      <ItemContainer>
        <Item width="60%">
          <Text strong style={{ display: 'block' }}>
            Usuário
          </Text>
          <Text type="secondary" style={{ display: 'block' }}>
            {safeRead(user, ['person_display', 'name_display'])}
          </Text>
        </Item>
        <Item width="35%">
          <Text strong style={{ display: 'block' }}>
            Mês/Ano
          </Text>
          <Text type="secondary" style={{ display: 'block' }}>
            {`${moment(`${year}-${month}`).format('MMMM/YYYY')}`}
          </Text>
        </Item>
        <Item width="35%">
          <Text strong style={{ display: 'block' }}>
            Valor/Hora
          </Text>
          <Text type="secondary" style={{ display: 'block' }}>
            {safeRead(user, ['general', 'hourly_rate'], '--', rate =>
              formatPrice(rate)
            )}
          </Text>
        </Item>
      </ItemContainer>

      <Formik
        initialValues={{
          value: 1,
          team: null,
          reason: '',
        }}
        onSubmit={async values => {
          await PostPayableRequest(
            key,
            values,
            'pacote',
            setPackageSolicitationModalVisible
          );
          await fetchCompensatoryTime(key, setCompensatoryTime);
          await fetchTableData(
            key,
            month,
            year,
            setTableData,
            setLoadingTableData
          );
          await fetchConsolidatedProduction(
            year,
            month,
            setConsolidatedProduction
          );
        }}
      >
        {({ handleSubmit, values, setFieldValue }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <Text strong style={{ display: 'block' }}>
                    Valor do Pacote
                  </Text>
                  <Field
                    id="value"
                    name="value"
                    component={InputCurrency}
                    min={0}
                    max={100000000}
                    onChange={(obj, val) => {
                      setFieldValue('value', val);
                    }}
                  />
                </Col>
                <Col>
                  <Text strong>Equipe</Text>
                  <Field
                    id="team-input-select"
                    name="team"
                    mode="single"
                    loading={loading}
                    component={AutoCompleteSelect}
                    selectSchema={({ id, team_name }) => (
                      <Select.Option key={id} value={id}>
                        {team_name}
                      </Select.Option>
                    )}
                    onChange={e => {
                      setFieldValue('team', e);
                      setSearch(undefined);
                    }}
                    search={debounce(setSearch, 800)}
                    data={teamsResponse}
                    allowClear
                  />
                </Col>
                <Col>
                  <Text strong style={{ display: 'block' }}>
                    Motivo
                  </Text>
                  <Field
                    id="reason"
                    name="reason"
                    component={Input}
                    type="textarea"
                  />
                </Col>
              </Row>
              <Row type="flex" justify="end">
                <Col>
                  <Button
                    onClick={() => {
                      setPackageSolicitationModalVisible(false);
                    }}
                  >
                    Cancelar
                  </Button>
                  <Divider type="vertical" />
                  <Button
                    id="amount-btn"
                    type="primary"
                    htmlType="submit"
                    disabled={!values.value || !values.team || !values.reason}
                  >
                    Confirmar
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}

PackageSolicitationModal.propTypes = {
  packageSolicitationModalVisible: PropTypes.bool.isRequired,
  setPackageSolicitationModalVisible: PropTypes.func.isRequired,
};
